<template>
    <h4 class="text-center">Your request has been matched with the following providers</h4>
    <div class="mt-3">
        <div class="container text-center">
            <div class="row row-cols-md-2 gx-3 gy-3 justify-content-center my-4">
                <div class="col" v-for="(buyerObject, id, index) in this.buyers" :key="index">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="mt-2" style="display: flex; justify-content: center; align-items: center; height: 80px;">
                                    <img :src="buyerObject.logo" :alt="buyerObject.name + ' logo'"
                                        style="max-height:80px; max-width:110px;">
                                </div>
                                <div class="">
                                    <p class="h6 mt-4" v-html="buyerObject.ty_page_msg ?? buyerObject.ty_page_msg_alt ?? ''"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Buyers',
    components: {
    },
    props: {
        buyers: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        const testData = true;

        return {
            testData,
        };
    },
    methods: {
    },
    computed: {
        testComputed() {
            return true;
        },
    },
    created() {
        // console.log('Buyers created');
    },
    mounted() {
        // console.log('Buyers mounted');
    },
    watch: {
    }
};
</script>
